import React from "react";

const PhysicalBillTrackingCard = ({
  data = {},
  onClick
}) => {

  // ==========================================
  // PHYSICAL BILL PENDING COUNTS
  // ==========================================

  const storePending =
    Number(
      data?.totalPendingPhysicalBillStore || 0
    );

  const billingPending =
    Number(
      data?.totalPendingPhysicalBillBilling || 0
    );

  const accountsPending =
    Number(
      data?.totalPendingPhysicalBillAccounts || 0
    );

  const totalPending =
    Number(
      data?.totalPhysicalBillPending || 0
    );


  // ==========================================
  // OPEN PHYSICAL BILL DASHBOARD
  // ==========================================

  const handleViewDetails = () => {

    if (!onClick) {
      return;
    }

    onClick("physicalBill");

  };


  return (

    <div
      className="card border-0 mb-3"
      style={{
        borderRadius: "16px",
        overflow: "visible",
        background: "transparent",
        boxShadow:
          "0 6px 18px rgba(0,0,0,0.08)"
      }}
    >

      {/* ==========================================
          HEADER
      ========================================== */}

      <div
        className="
          d-flex
          justify-content-between
          align-items-center
          flex-wrap
          gap-2
        "
        style={{
          padding: "10px 14px 3px 14px"
        }}
      >

        <div>

          <div
            className="
              d-flex
              align-items-center
              gap-2
              flex-wrap
            "
          >

            <h4
              className="mb-0"
              style={{
                fontSize: "17px",
                fontWeight: 700,
                color: "#212529"
              }}
            >
              Physical Bill Processing
            </h4>

            <span
              className="badge"
              style={{
                background: "#198754",
                color: "#ffffff",
                border: "1px solid #198754",
                fontSize: "9px",
                padding: "4px 8px"
              }}
            >
              NEW
            </span>

          </div>

          <div
            className="mt-1"
            style={{
              color: "#6c757d",
              fontSize: "10px"
            }}
          >
            Overview of pending physical bill processing
          </div>

        </div>


        {/* VIEW DETAILS */}

        <button
          type="button"
          className="btn btn-sm"
          onClick={handleViewDetails}
          style={{
            color: "#343a40",
            border: "1px solid #ced4da",
            borderRadius: "8px",
            padding: "5px 11px",
            fontSize: "11px",
            fontWeight: 600,
            boxShadow:
              "0 2px 6px rgba(0,0,0,0.06)"
          }}
        >
          View Details
        </button>

      </div>


      {/* ==========================================
          BODY
      ========================================== */}

      <div
        style={{
          padding: "8px 12px 18px"
        }}
      >

        <div className="row g-2">


          {/* ======================================
              1. TOTAL PENDING
          ====================================== */}

          <div
            className="
              col-xl-3
              col-lg-3
              col-md-6
              col-sm-12
            "
          >

            <div
              style={{
                minHeight: "88px",
                height: "100%",
                borderRadius: "11px",
                padding: "12px",

                background:
                  "linear-gradient(135deg, #20c997 0%, #198754 100%)",

                boxShadow:
                  "0 6px 14px rgba(0,70,45,0.20)"
              }}
            >

              <div
                className="
                  d-flex
                  align-items-center
                  gap-2
                "
              >

                <div
                  className="
                    d-flex
                    align-items-center
                    justify-content-center
                  "
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    background:
                      "rgba(255,255,255,0.20)",
                    flexShrink: 0
                  }}
                >

                  <i
                    className="fa fa-files-o"
                    style={{
                      fontSize: "18px",
                      color: "#ffffff"
                    }}
                  />

                </div>


                <div>

                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: 700,
                      lineHeight: 1,
                      color: "#ffffff"
                    }}
                  >
                    {totalPending}
                  </div>

                  <div
                    className="mt-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#ffffff"
                    }}
                  >
                    Total Pending
                  </div>

                </div>

              </div>


              <div
                className="mt-2"
                style={{
                  fontSize: "9px",
                  color:
                    "rgba(255,255,255,0.90)"
                }}
              >
                Total pending physical bills
              </div>

            </div>

          </div>


          {/* ======================================
              2. STORE PENDING
          ====================================== */}

          <div
            className="
              col-xl-3
              col-lg-3
              col-md-6
              col-sm-12
            "
          >

            <div
              style={{
                minHeight: "88px",
                height: "100%",
                borderRadius: "11px",
                padding: "12px",

                background:
                  "linear-gradient(135deg, #6f42c1 0%, #512da8 100%)",

                boxShadow:
                  "0 6px 14px rgba(0,0,0,0.16)"
              }}
            >

              <div
                className="
                  d-flex
                  align-items-center
                  gap-2
                "
              >

                <div
                  className="
                    d-flex
                    align-items-center
                    justify-content-center
                  "
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    background:
                      "rgba(255,255,255,0.20)",
                    flexShrink: 0
                  }}
                >

                  <i
                    className="fa fa-building"
                    style={{
                      fontSize: "18px",
                      color: "#ffffff"
                    }}
                  />

                </div>


                <div>

                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: 700,
                      lineHeight: 1,
                      color: "#ffffff"
                    }}
                  >
                    {storePending}
                  </div>

                  <div
                    className="mt-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#ffffff"
                    }}
                  >
                    Store Pending
                  </div>

                </div>

              </div>


              <div
                className="mt-2"
                style={{
                  fontSize: "9px",
                  color:
                    "rgba(255,255,255,0.90)"
                }}
              >
                Physical summary yet to be generated
              </div>

            </div>

          </div>


          {/* ======================================
              3. BILLING PENDING
          ====================================== */}

          <div
            className="
              col-xl-3
              col-lg-3
              col-md-6
              col-sm-12
            "
          >

            <div
              style={{
                minHeight: "88px",
                height: "100%",
                borderRadius: "11px",
                padding: "12px",

                background:
                  "linear-gradient(135deg, #2196f3 0%, #1565c0 100%)",

                boxShadow:
                  "0 6px 14px rgba(0,0,0,0.16)"
              }}
            >

              <div
                className="
                  d-flex
                  align-items-center
                  gap-2
                "
              >

                <div
                  className="
                    d-flex
                    align-items-center
                    justify-content-center
                  "
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    background:
                      "rgba(255,255,255,0.20)",
                    flexShrink: 0
                  }}
                >

                  <i
                    className="fa fa-file-text"
                    style={{
                      fontSize: "18px",
                      color: "#ffffff"
                    }}
                  />

                </div>


                <div>

                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: 700,
                      lineHeight: 1,
                      color: "#ffffff"
                    }}
                  >
                    {billingPending}
                  </div>

                  <div
                    className="mt-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#ffffff"
                    }}
                  >
                    Billing Pending
                  </div>

                </div>

              </div>


              <div
                className="mt-2"
                style={{
                  fontSize: "9px",
                  color:
                    "rgba(255,255,255,0.90)"
                }}
              >
                Physical bills waiting with Billing
              </div>

            </div>

          </div>


          {/* ======================================
              4. ACCOUNTS PENDING
          ====================================== */}

          <div
            className="
              col-xl-3
              col-lg-3
              col-md-6
              col-sm-12
            "
          >

            <div
              style={{
                minHeight: "88px",
                height: "100%",
                borderRadius: "11px",
                padding: "12px",

                background:
                  "linear-gradient(135deg, #ff9800 0%, #ef6c00 100%)",

                boxShadow:
                  "0 6px 14px rgba(0,0,0,0.16)"
              }}
            >

              <div
                className="
                  d-flex
                  align-items-center
                  gap-2
                "
              >

                <div
                  className="
                    d-flex
                    align-items-center
                    justify-content-center
                  "
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    background:
                      "rgba(255,255,255,0.20)",
                    flexShrink: 0
                  }}
                >

                  <i
                    className="fa fa-calculator"
                    style={{
                      fontSize: "18px",
                      color: "#ffffff"
                    }}
                  />

                </div>


                <div>

                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: 700,
                      lineHeight: 1,
                      color: "#ffffff"
                    }}
                  >
                    {accountsPending}
                  </div>

                  <div
                    className="mt-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#ffffff"
                    }}
                  >
                    Accounts Pending
                  </div>

                </div>

              </div>


              <div
                className="mt-2"
                style={{
                  fontSize: "9px",
                  color:
                    "rgba(255,255,255,0.90)"
                }}
              >
                Physical bills waiting with Accounts
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  );

};

export default PhysicalBillTrackingCard;